const getDefaultState = () => {
    return {
        forbiddenCriteria: [],
        forbiddenList: [],
        previousValue: null,
        currentElement: null,
        actionType: null
    }
}

const forbiddenCriteria = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        setForbiddenCriteria(state, data) {
            state.forbiddenCriteria = data
        },
        setForbiddenList(state, data) {
            state.forbiddenList = data
        },
        setPreviousValue(state, data) {
            state.previousValue = data
        },
        setCurrentElement(state, data) {
            state.currentElement = data
        },
        setActionType(state, data) {
            state.actionType = data
        }
    }
}

export default forbiddenCriteria